import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

export function PageHeading() {
	return (
		<div className="space-y-2 pt-6 text-typography-strong md:pt-10">
			<Text className="text-typography-weak">
				<Translate value="corgi.topic_page_sitemap.page_heading.subtitle" />
			</Text>

			<Text as="h1" variant="heading" size="x-large">
				<Translate value="corgi.topic_page_sitemap.page_heading.title" />
			</Text>
		</div>
	);
}
